module.exports = __webpack_public_path__ + "static/media/Polygon_Light.5224c098.svg";